/** Flaga pokazywana, gdy kraj jest nieznany albo jeszcze się nie doczytał. */
const UNKNOWN_FLAG = '/assets/img/flags/UNKNOWN.png'

/**
 * Ścieżka do flagi kraju.
 *
 * Przyjmuje `undefined`/`null` celowo: wywołania idą przez łańcuchy w rodzaju
 * `marker?.country?.code`, więc brak kodu to normalny stan, a nie błąd. Wcześniej
 * funkcja wołała `code.toUpperCase()` bez zabezpieczenia i taki przypadek wywracał
 * cały komponent (`Cannot read properties of undefined (reading 'toUpperCase')`).
 */
export const getCountryFlag = (code?: string | null) => {
  const normalized = code?.trim().toUpperCase()
  if (!normalized) return UNKNOWN_FLAG

  return `/assets/img/flags/${normalized}.png`
}
